import { combineReducers } from 'redux';

import * as types from 'modules/followUp/actionTypes';
import { FOLLOW_DASHBOARD_SOURCE } from 'modules/followUp/constant';
import loadingReducer from 'modules/global/reducers/generic.loading';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';

import filters from './filters';

/**
 * @typedef {{
 *   dashboard: {
 *     filters: import("./filters").FollowUpFiltersReducer,
 *     data: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *     loading: {
 *       scheduling: boolean,
 *     }
 *   }
 * }} FollowUpUIReducer
 */

const followUpDashboardMatcher = ({ meta }) => meta?.source === FOLLOW_DASHBOARD_SOURCE;

export default combineReducers({
  dashboard: combineReducers({
    filters,
    loading: combineReducers({
      scheduling: loadingReducer(types.SCHEDULE_FOLLOW_UP),
    }),
    data: createSearchReducers(types.FETCH_FOLLOW_UPS, {
      global: { matcher: followUpDashboardMatcher, paginationSlice: true },
    }),
  }),
});
